import React from "react"

import { styled } from "@mui/material"

const Columns = ({ children, columns = 3, ...rest }) => {
  const StyledColumns = styled("div", {
  })(({ columns = 3, theme }) => {
    return {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      width: "100%",
      "& .section-body": {
        marginBottom: theme.spacing(2)
      },
      "& >div": {
        width: `calc(100% / ${columns})`
      },
      [theme.breakpoints.down("md")]: {
        "& >div": {
          width: `calc(100% / ${Math.max(columns - 1, 1)})`
        }
      },
      [theme.breakpoints.down("sm")]: {
        "& >div": {
          width: "100%"
        }
      }
    }
  })

  return <StyledColumns
    columns={columns}
    {...rest}
  >
    {children}
  </StyledColumns>
}

export default React.memo(Columns)